import * as ss from 'superstruct';

/**
 * The configuration for sending conversions to Meta. Used for sending

 * Also used by analytics to report on stats.
 */
export const MetaAdsOutputStreamDestination = ss.type({
  name: ss.literal('meta-ads'),
  /** The Meta Access token. Generated per pixel. Write-only: masked on read. */
  accessToken: ss.string(),
  /** The Meta pixel ID for the organization. */
  pixelId: ss.string(),
  /** Event name to post in  */
  eventName: ss.string(),
});

export type MetaAdsOutputStreamDestination = ss.Infer<
  typeof MetaAdsOutputStreamDestination
>;
